import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'

import {
    faAngleDown,
    faAngleLeft,
    faArrowDownRight,
    faArrowLeftFromLine,
    faArrowLeftLong,
    faArrowLeftToBracket,
    faArrowLeftToLine,
    faArrowRight,
    faArrowRightFromLine,
    faArrowRightLong,
    faArrowRightToLine,
    faArrowUpArrowDown,
    faArrowUpRight,
    faArrowUpRightFromSquare,
    faArrowsFromLine,
    faArrowsMaximize,
    faAtomSimple,
    faBackwardStep,
    faBars,
    faBarsFilter,
    faBook,
    faBookmark,
    faBooks,
    faBoxesStacked,
    faBuilding,
    faBuildings,
    faBullseye,
    faCalendar,
    faCaretDown,
    faCaretRight,
    faChartLine,
    faChartLineUp,
    faChartNetwork,
    faChartScatter,
    faChartSimple,
    faChartTreeMap,
    faCheck,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronsLeft,
    faCircle,
    faCircleArrowDown,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleArrowUp,
    faCircleDollar,
    faCircleExclamation,
    faCircleInfo,
    faCircleMinus,
    faCirclePlus,
    faCity,
    faCoffeePot,
    faCodeCompare,
    faColumns3,
    faCog,
    faConveyorBeltBoxes,
    faCrown,
    faCubesStacked,
    faDiagramSuccessor,
    faDownload,
    faDumbbell,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faExclamation,
    faExternalLink,
    faEye,
    faFileArrowDown,
    faFileContract,
    faFlag,
    faGaugeSimpleHigh,
    faGavel,
    faGear,
    faGlobe,
    faHashtag,
    faGrid2,
    faHeadset,
    faHome,
    faHourglassEnd,
    faLightbulbOn,
    faListDropdown,
    faTableList,
    faListTree,
    faLocationCrosshairs,
    faLock,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMemo,
    faMerge,
    faMicrochip,
    faMoneyBillWave,
    faObjectsColumn,
    faPaperPlane,
    faPaperclip,
    faPeopleGroup,
    faPencil,
    faPhone,
    faPlus,
    faPrint,
    faPuzzle,
    faPuzzlePieceSimple,
    faRankingStar,
    faRotate,
    faRuler,
    faSackDollar as fasSackDollar,
    faScroll,
    faSeedling,
    faShuffle,
    faSitemap,
    faSparkles,
    faSquareArrowUpRight,
    faSquareList,
    faStar,
    faSwords,
    faTableLayout,
    faTableTree,
    faText,
    faThList,
    faThumbTack,
    faTimeline,
    faTrashCan,
    faTriangleExclamation,
    faTruckContainer,
    faUser,
    faUserGroupCrown,
    faUserTie,
    faViolin,
    faWifi,
    faWifiFair,
    faWifiWeak,
    faXmark,
    faListTimeline,
} from '@fortawesome/pro-solid-svg-icons'
import { faStore as fadStore } from '@fortawesome/pro-duotone-svg-icons'
import {
    faCircleQuestion,
    faDiagramSubtask,
    faFileLines,
    faSackDollar,
    faSitemap as farSitemap,
} from '@fortawesome/pro-regular-svg-icons'
import { faCircleExclamation as falCircleExclamation } from '@fortawesome/pro-light-svg-icons'

library.add(
    faPeopleGroup,
    faStar,
    faCircleMinus,
    faGear,
    faSparkles,
    faTimeline,
    faGrid2,
    faBullseye,
    faPencil,
    faBoxesStacked,
    faMemo,
    faCity,
    faCoffeePot,
    faChartTreeMap,
    faDumbbell,
    faDiagramSuccessor,
    faThumbTack,
    faSwords,
    faObjectsColumn,
    faArrowsFromLine,
    faRotate,
    faRuler,
    faPuzzlePieceSimple,
    faPuzzle,
    faViolin,
    faMerge,
    faChartNetwork,
    faTableLayout,
    faChevronsLeft,
    faPrint,
    faAtomSimple,
    faAngleLeft,
    faAngleDown,
    faArrowDownRight,
    faArrowLeftToBracket,
    faArrowUpArrowDown,
    faBars,
    faBarsFilter,
    faArrowLeftFromLine,
    faArrowRightFromLine,
    faArrowRightToLine,
    faArrowLeftToLine,
    faArrowRight,
    faArrowRightLong,
    faArrowLeftLong,
    faArrowUpRight,
    faArrowUpRightFromSquare,
    faBackwardStep,
    faBookmark,
    faBooks,
    faBuilding,
    faBuildings,
    faCalendar,
    faChartSimple,
    faCaretRight,
    faCaretDown,
    faChartLine,
    faChartLineUp,
    faCheck,
    faChevronDown,
    faChevronRight,
    faChevronLeft,
    faCircle,
    faCircleArrowRight,
    faCircleArrowLeft,
    faCircleArrowUp,
    faCircleArrowDown,
    faCircleDollar,
    faCircleInfo,
    faCirclePlus,
    faCircleQuestion,
    faCodeCompare,
    faColumns3,
    faCog,
    faConveyorBeltBoxes,
    faCrown,
    faDiagramSubtask,
    faDownload,
    fadStore,
    faEarthAmericas,
    faEdit,
    faEllipsisH,
    faEllipsisVertical,
    faEnvelope,
    faEye,
    faExclamation,
    faExternalLink,
    faFileLines,
    faFileArrowDown,
    faFlag,
    faLock,
    faGlobe,
    faHashtag,
    faHeadset,
    faHome,
    faListDropdown,
    faTableList,
    faListTree,
    faLocationCrosshairs,
    faMagnifyingGlass,
    faMapMarkerAlt,
    faMicrochip,
    faMoneyBillWave,
    faPaperPlane,
    faPaperclip,
    faPhone,
    faPlus,
    faRankingStar,
    farSitemap,
    faSackDollar,
    faSitemap,
    faSquareArrowUpRight,
    fasSackDollar,
    faTableTree,
    faText,
    faThList,
    faTrashCan,
    faTriangleExclamation,
    faTruckContainer,
    faUser,
    faUserTie,
    faXmark,
    faFileContract,
    faChartScatter,
    faScroll,
    falCircleExclamation,
    faCircleExclamation,
    faBook,
    faLightbulbOn,
    faSquareList,
    faGaugeSimpleHigh,
    faGavel,
    faSeedling,
    faHourglassEnd,
    faShuffle,
    faCubesStacked,
    faUserGroupCrown,
    faWifi,
    faWifiFair,
    faWifiWeak,
    faArrowsMaximize
)

export default FontAwesomeIcon
